import {Snum} from "./Types";

export class ActionMap<A extends Snum, R extends unknown[] = [], RR = unknown> {
    private map = new Map<string, (...rest: R) => RR>()

    public on(...set: A[]): Capture<this, RR, R> {
        return new Capture((cb) => {
            validateState(set);

            const state = createState(set);

            if (this.map.has(state)) {
                throw new Error("Action cb for " + state + " already exists")
            }

            this.map.set(state, cb);

            return this;
        })
    }

    public override(...set: A[]): Capture<this, RR, R>  {
        return new Capture((cb) => {
            validateState(set);
            const state = createState(set);
            this.map.set(state, cb);
            return this;
        })
    }

    public selector(): ActionSelector<A,  R, RR>  {
      return new ActionSelector<A, R, RR>(this.map);
    }

}

class Capture<CR, RR, R extends unknown[] = []> {
    constructor(private onDo: (cb: (...r: R) => RR) => CR)  {

    }

    public do(cb: (...r: R) => RR): CR {
        return this.onDo(cb);
    }
}

class ActionSelector<A extends Snum, R extends unknown[], RR> {
    private map = new Map<any, (...rest: R) => RR>()

    constructor(map: Map<any, (...rest: R) => RR>) {
        this.map = new Map(map)
    }

    public for(...actions: A[]): Executor<R, RR> {
        const state = createState(actions);
        if (!this.map.has(state)) {
            throw new Error("No such action set defined " + state)
        }

        return new Executor(this.map.get(state)!!)
    }
}

class Executor<R extends unknown[], RR> {

    constructor(private fun: (...rest: R) => RR) {
    }

    public execute(...vals: R): RR {
         return this.fun(...vals)
    }
}


function createState<A extends Snum>(set: Array<A>): string {
    return set.sort().join("|");
}


function validateState<A extends Snum>(set: Array<A>) {
    if (set.some(it => String(it).includes("|"))) {
        throw new Error("Set should not contain '|'; I'm to lazy to write a proper implementation");
    }
}